<template>
  <div>
    <common-dialog
      ref="dialog"
      width="650px"
      show-save-button
      unit="节假日"
      id-key="SectionId"
      :data="data"
      form-label-width="100px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="节假日名称" prop="HolidayName" >
              <el-input size="mini" v-model="data.HolidayName" placeholder="请填写节假日名称" :style="isMB?'':'width:200px;'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="开始日期" prop="StartDate" >
               <el-date-picker
                v-model="data.StartDate"
                value-format="yyyy-MM-dd"
                size="mini"
                :style="isMB?'width:auto;':'width:200px;'"
                placeholder="请选择开始时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="结束日期" prop="EndDate" >
               <el-date-picker
                v-model="data.EndDate"
                value-format="yyyy-MM-dd"
                size="mini"
                :style="isMB?'width:auto;':'width:200px;'"
                placeholder="请选择结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="isMB?24:12">
            <el-form-item label="状态" prop="Status">
              <el-radio-group v-model="data.Status">
                <el-radio label="启用"></el-radio>
                <el-radio label="停用"></el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col> -->
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import termApi from "@/api/ed/term";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        HolidayId: 0,
        HolidayName: "",
        StartDate: "",
        EndDate: "",
        // Status: "启用",
      },
      api: require("@/api/ed/holiday").default,
      termApi,
      isMB: this.$store.state.isMB,
      rules: {
        HolidayName: [{ required: true, message: "请填写节假日名称" }],
        StartDate: [{ required: true, message: "请选择开始时间" }],
        EndDate: [{ required: true, message: "请选择结束时间" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
    },
    onEditOpened(row) {
    },
    onBeforeSave() {
      if(this.data.StartDate > this.data.EndDate) {
        this.$message.error("开始时间不能在结束日期之后")
        return false
      }
    },
  },
};
</script>
<style lang="scss">
</style>